import React, { useEffect, useState } from 'react';

import SocialLinks from '../../../main/components/socialLinks';
import Emitter from '../../../utils/emitter';
import client from '../../../utils/prismicHelpers';
import * as queries from "../../../utils/prismicQueries";
import './footer.css'
import FooterCol from './FooterCol';
import QuickLink from './QuickLink';
const Footer = ({ children }) => {
    const [footer, setFooter] = useState(null);

    const [footerNavigations, setFooterNavigation] = useState(null);
    useEffect(() => {
        client
            .query({
                query: queries.footer,
            })
            .then((response) => {
                const footerLink = response.data.allFooters.edges[0].node;
                const footerNavigation = response.data.allNavbar2s.edges[0].node?.nav_link;
                setFooter(footerLink);
                setFooterNavigation(footerNavigation);
            })
            .catch((error) => {
                console.error(error);
            });
    });
    const handleNavSelector = (dropNo, area) => {

        sessionStorage.setItem("dropNo", dropNo);
        if (area == "Innovation Fellow" || area == "Investment Committee" || area == "Venture Fund" || area == "Cohorts" || area == "View Programs") {
            sessionStorage.setItem("InnovationSection", area);
            Emitter.emit("MOVE_INNOVATION_SECTION", area);
        }
    }
    return (
        <footer className="footer-container">
            <div className="container  py-0">
                <div className="row px-4 px-md-0">
                    {footerNavigations?.slice(0, 3)?.map((navigation, index) => <FooterCol index={index + 1} key={index + 1} handleNavSelector={handleNavSelector} navigation={navigation} />)}
                    {footerNavigations?.slice(4, 5)?.map((navigation, index) => <FooterCol index={index + 5} key={index + 10} handleNavSelector={handleNavSelector} navigation={navigation} />)}

                    <ul className="col-md-2  list-unstyled py-md-5 py-0">
                        <li className="py-2"><a className="  secondary-text text-uppercase   footer-title" >Quick link</a></li>
                        {footerNavigations?.slice(5, 6)?.map((navigation, index) => <QuickLink handleNavSelector={handleNavSelector} index={6} navigation={navigation} key={index + 30} />)}
                        {footerNavigations?.slice(3, 4)?.map((navigation, index) => <QuickLink handleNavSelector={handleNavSelector} index={4} navigation={navigation} key={index + 20} />)}
                        {footerNavigations?.slice(4, 5)?.map((navigation, index) => <QuickLink handleNavSelector={handleNavSelector} index={5} key={index + 10} navigation={navigation} company={true} />)}

                    </ul>
                    <ul className="col-md-2 list-unstyled py-md-5 py-2   ">
                        <li className="py-2"><a className="  secondary-text  footer-title" >Follow Us</a></li>
                        <div className="bottom-footer ">
                            <SocialLinks />
                        </div>
                    </ul>
                    <div className="d-flex links align-items-center">
                        {children ? children :
                            <>

                                <a href={footer?.footer_link[0].link[0]?.text} className="muted-test  m-0">{footer?.footer_link[0].link_text[0]?.text}</a>
                                <a target="_blank" href={footer?.footer_link[1].doc?.url} className=" m-0 primary-text pe-4">{footer?.footer_link[1].link_text[0]?.text}</a>
                                <a target="_blank" href={footer?.footer_link[2].doc?.url} className=" m-0 primary-text">{footer?.footer_link[2].link_text[0]?.text}</a>
                            </>
                        }
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;